import { render } from "./breakdown-card.vue?vue&type=template&id=259d901b&scoped=true"
import script from "./breakdown-card.vue?vue&type=script&lang=js"
export * from "./breakdown-card.vue?vue&type=script&lang=js"

import "./breakdown-card.vue?vue&type=style&index=0&id=259d901b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259d901b"]])

export default __exports__